import { createAction } from "@reduxjs/toolkit";

import {
  getMySupportersActionTypes,
  getMySupportersPortionActionTypes,
  getSupportersByIdActionTypes,
  getSupportersByIdPortionActionTypes,
} from "./actionTypes";

export const getMySupporters = createAction(
  getMySupportersActionTypes.request,
  (payload) => ({ payload }),
);

export const getMySupportersSuccess = createAction(
  getMySupportersActionTypes.success,
  (payload) => ({ payload }),
);

export const getMySupportersFailure = createAction(
  getMySupportersActionTypes.failure,
  (error) => ({ payload: error }),
);

export const getMySupportersPortion = createAction(
  getMySupportersPortionActionTypes.request,
  (payload) => ({ payload }),
);

export const getMySupportersPortionSuccess = createAction(
  getMySupportersPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getMySupportersPortionFailure = createAction(
  getMySupportersPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const getSupportersById = createAction(
  getSupportersByIdActionTypes.request,
  (payload) => ({ payload }),
);

export const getSupportersByIdSuccess = createAction(
  getSupportersByIdActionTypes.success,
  (payload) => ({ payload }),
);

export const getSupportersByIdFailure = createAction(
  getSupportersByIdActionTypes.failure,
  (payload) => ({ payload }),
);

export const getSupportersByIdPortion = createAction(
  getSupportersByIdPortionActionTypes.request,
  (payload) => ({ payload }),
);

export const getSupportersByIdPortionSuccess = createAction(
  getSupportersByIdPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getSupportersByIdPortionFailure = createAction(
  getSupportersByIdPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const supportersReset = createAction(getMySupportersActionTypes.reset);
